const o = "bento_";
export { o as PREFIX };
